import "./tablestyle.scss";
import { Grid, GridCellProps, GridColumn as Column, GridSortChangeEvent, GridNoRecords } from "@progress/kendo-react-grid";
import { DropDown } from "./myDropDown";
import { useState } from "react";
import { AllocatedDropdown } from "./allocatedDropdown";
import PopOver from "../popover";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import * as CONSTANTS from '../../utils/CONSTANTS';
import { getMilliSec, getMilliSecUTC } from "../../utils/EllowUtils";
import { useNavigate } from "react-router-dom";
import { updateAvailablity, updateCandidateStatus, deleteDraftFreelancer } from "./services";
import DateEditor from '../../modal/dateEdit'
import WeekEditor from "../../modal/weekEdit"
import TextArea from "../../modal/textArea"
import { orderBy, SortDescriptor } from "@progress/kendo-data-query";
import SelectCertifications from "../../modal/certificationSelect";
import { Icon } from '@iconify/react';
import ConfirmationModal from "../../modal/confirmation/confirmationModal";
import NotificationAlert from "../../components/notification";
import { getAPI, postAPI } from "../../api/api";

const userLoginId = localStorage.getItem('loginId')

const PublicDatabaseTable = (props: any) => {

    const [allocatedTo, setAllocatedTo] = useState<any>();
    const [date, setDate] = useState<boolean>(false)
    const [week, setWeek] = useState<boolean>(false)
    const [modal, setModal] = useState<boolean>(false)
    const [loginId, setLoginId] = useState<any>()
    const [candidateStatus, setCandidateStatus] = useState<number>()
    const [showCertification, setShowCertification] = useState<boolean>(false)
    const [certifications, setCertifications] = useState<any>()
    const [confirmation, setConfirmation] = useState<boolean>(false)
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')

    let newDate = new Date()
    const navigate = useNavigate()

    const initialSort: Array<SortDescriptor> = [
        { field: "", dir: "asc" },
    ];

    const [sort, setSort] = useState(initialSort);


    const rowClick = (e: any) => {
        props.rowClick(e)

    }

    const getTableValues = () => {
        props.getResourceTables()

    }

    const dateChange = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setDate(true)
        setWeek(false)
    }

    const weekChange = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setWeek(true)
        setDate(false)
    }

    const rejected = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setCandidateStatus(6)
        setModal(true)

    }

    const blackListed = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setCandidateStatus(7)
        setModal(true)

    }

    const onSubmit = (data: any, type: string) => {
        if (type === 'weeks') {
            let value = {
                "loginId": loginId,
                "availability": {
                    "date": 0,
                    "weeks": data,
                    "availabilityId": 3,
                    "lastUpdateDate": getMilliSecUTC(newDate),

                },
                "userLoginId": userLoginId,
                "submittedBy": 'RECRUITER'
            }
            updateAvailablity(value).then((response: any) => {
                getTableValues()
            })
        }
        if (type === 'date') {
            let value = {
                "loginId": loginId,
                "availability": {
                    "date": data,
                    "weeks": 0,
                    "availabilityId": 2,
                    "lastUpdateDate": getMilliSecUTC(newDate),
                },
                "userLoginId": userLoginId,
                "submittedBy": 'RECRUITER'
            }
            updateAvailablity(value).then((response: any) => {
                getTableValues()
            })
        }
    }

    const submitRemarks = (data: any) => {

        let value = {
            "loginId": loginId,
            "userLoginId": userLoginId,
            "candidateStatus": candidateStatus,
            "rejectComment": data
        }
        updateCandidateStatus(value).then((response: any) => {
            if (response && response.status === 1) {
                getTableValues()
            }
        })
    }
    //vishnu
    const openInNewTab = (url: any) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const redirection = (candidateLoginId: string) => {
        localStorage.setItem('candidateLoginId', candidateLoginId);
        localStorage.setItem('ResourcesCandidateLoginId', candidateLoginId);
        localStorage.setItem('ResourcesTab', '6');
        openInNewTab(`${window.location.origin}/createResources`)
        // navigate('../createResources', { state: { candidateLoginId: candidateLoginId, tab: 4 } })
    }

    function ShowCertificationPopup(data: any) {
        setLoginId(data.dataItem.loginId);
        setShowCertification((prev) => !prev)
        setCertifications(data.dataItem.ellowScreeningCertifications);
    }

    const deleteMyDraft = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setConfirmation(true)
    }

    const deleteMyDraftFreelancer = () => {
        deleteDraftFreelancer(loginId).then((response: any) => {
            if (response.statusCode === 200) {
                props.getResourceTables()
                setMessage('Details deleted successfully')
                displayNotification()
            }
        })
    }

    const certificationCell = (props: GridCellProps) => {
        let ellowScreeningCertifications = props.dataItem.ellowScreeningCertifications;
        let length = ellowScreeningCertifications && ellowScreeningCertifications.length;
        let skillcombine = ellowScreeningCertifications && ellowScreeningCertifications.map((dataskill: any) => {
            return dataskill.skills && dataskill.skills.name;
        }
        ).join(",");
        return (
            <td onClick={() => ShowCertificationPopup(props)}>
                <div className="positionStstus no-wrap">
                    <PopOver title={skillcombine}
                        position="Bottom">
                        {ellowScreeningCertifications && ellowScreeningCertifications.map((skillData: any, key: any) => {
                            return (<div key={key} className="positionList">   <span className="status warning" /><strong>{skillData.skills && skillData.skills.name} - {skillData.certificationType} </strong> </div>);
                        })}
                    </PopOver>
                </div>
            </td>
        )
    }

    const displayNotification = () => {
        setNotification(true)
        setTimeout(() => {
            setNotification(false)
        }, 3000)
    }

    const onClose = () => {
        setNotification(false)
    }

    return (
        <>
            <Grid
                data={props.state.items}
                onPageChange={props.pageChange}
                total={props.state.total}
                skip={props.state.skip}
                pageable={props.state.pageable}
                pageSize={props.state.pageSize}
                onItemChange={props.itemChange}
                onRowClick={(e) => rowClick(e)}
                // data={props.state.items && orderBy(props.state.items, sort)}
                // onSortChange={(e: GridSortChangeEvent) => {
                //   setSort(e.sort); props.getTableValues()
                // }}
                sortable={true}
                sort={sort}
                onSortChange={(e) => {
                    setSort(e.sort);
                    props.setSort(e.sort);
                    props.applySort(e.sort);

                }}
            >
                <GridNoRecords>
                    <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                    </div>
                </GridNoRecords>
                <Column field="name" title="Name" width="180" className="noWordWrap" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId))} />
                <Column field="Skills" title="Skills" cell={skillsCell} />
                <Column field="experience" title="Experience" cell={experienceCell} />
                <Column field="availabilityValue" title="Availability" cell={(props: GridCellProps) => DropDown(props, () => getTableValues(), () => dateChange(props), () => weekChange(props))} />
                <Column field="sourced_by" title="Sourced By" cell={sourced_by} />
                <Column
                    field="date_of_registration"
                    title="Date of Registration"
                    cell={dateCell}
                />

                {!props.hideStatus && <Column field="ellowStatus" title="ellow status" cell={(props: GridCellProps) => ellowStatusDropdown(props, () => getTableValues(), () => rejected(props), () => blackListed(props))} />}

                <Column field="allocatedTo" title="Allocated To" cell={(props: GridCellProps) => AllocatedDropdown(props, () => getTableValues())} />
                <Column field="source" title="Added From" />
                <Column cell={ViewButton} width="120px" />
                {props.draftKey && <Column cell={(props: GridCellProps) => deleteCell(props, (data: any) => deleteMyDraft(props))} width="70px" />}
            </Grid>
            {date && <DateEditor onClose={() => setDate(false)} onSubmit={onSubmit} />}
            {week && <WeekEditor onClose={() => setWeek(false)} onSubmit={onSubmit} loginId={loginId} />}
            {modal && <TextArea onClose={() => setModal(false)} onSubmit={submitRemarks} loginId={loginId} title={''} confirmation={'Are you sure you want to reject/blacklist?'} placeholder={'Reason For Rejection/Blacklisting'} mandatory={true} />}
            {showCertification && <SelectCertifications getTableValues={getTableValues} loginId={loginId} defaultValues={certifications} onClose={() => setShowCertification((prev) => !prev)} />}
            {confirmation && <ConfirmationModal onClose={() => setConfirmation(false)} submit={deleteMyDraftFreelancer} />}
            {notification && <NotificationAlert onClose={onClose} closable={true} > {message} </NotificationAlert>}
        </>
    )
}

export default PublicDatabaseTable;

const sourced_by = (props: GridCellProps) => {
    let sourcedBy = props.dataItem.sourcedBy;


    return <td><div className="dateWrap">{sourcedBy}</div></td>;
};


const dateCell = (props: GridCellProps) => {
    let dateNumber = parseInt(props.dataItem.dateOfRegistration);
    let date = new Date(dateNumber).toDateString();

    return <td><div className="dateWrap">{date}</div></td>;
};

const experienceCell = (props: GridCellProps) => {
    if (props.dataItem.experience !== null) {
        return <td>{props.dataItem.experience + " Years"}</td>;
    } else {
        return <td>{"Not Mentioned"}</td>;
    }
};


const skillsCell = (props: GridCellProps) => {

    let length = props.dataItem.skills && props.dataItem.skills.length;

    return (
        <td >
            <div className="skillsWrap">
                {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number) => {
                    return ((item) + (key < length - 1 ? ' , ' : ''))
                })}
            </div>
        </td>
    );
};



const ViewButton = (props: GridCellProps) => {

    const navigate = useNavigate()
    return (
        <td>
            <button type="button" className="applyButton"
                onClick={(e: any) => navigate('../jsonresponse', { state: { candidateId: props.dataItem.candidateId } })}>
                view Public Data
            </button>
        </td>
    );
}



const deleteCell = (props: GridCellProps, deleteMyDraft: any) => {
    return (
        <td>
            <button type="button" className="deleteButton" onClick={deleteMyDraft}>
                <Icon icon="material-symbols:delete-outline-rounded" />
            </button>
        </td>
    );
}

const nameCell = (props: GridCellProps, redirection: any) => {

    let currentDate = new Date().getTime()
    let dateOfRegistration = props.dataItem.dateOfRegistration
    var diff = (currentDate - dateOfRegistration) / 1000;
    diff /= (60 * 60);
    let diff2 = Math.abs(Math.round(diff));

    const profileImage = props.dataItem.googleProfileImage ? props.dataItem.googleProfileImage : " "

    return (
        <td className="statusWrap">
            {diff2 <= 24 &&
                <span className="userStatus">New</span>
            }
            <div className="userInfo" onClick={() => redirection(props.dataItem.loginId)}>
                {profileImage === " " ?
                    <figure>{props.dataItem && props.dataItem.firstName && props.dataItem.firstName[0]}{props.dataItem && props.dataItem.lastName && props.dataItem.lastName[0]}</figure>
                    :
                    <figure><img src={profileImage}></img></figure>
                }
                <div>
                    {props.dataItem.name}
                    <div className="email">{props.dataItem.email}</div>
                    <div className="phone">{props.dataItem.phoneNumber}</div>
                </div>
            </div>
        </td>
    )
}




const positionStatusCell = (props: GridCellProps) => {


    if (props.dataItem.positionStatus && props.dataItem.positionStatus.length > 1) {

        return (
            <td>
                <div className="positionStstus"><PopOver title="Multiple Position" position="rightBottom">
                    {props.dataItem.positionStatus && props.dataItem.positionStatus.map((item: any, key: number) => {
                        return (
                            <div key={key} className="positionList">
                                <span className="status warning" />
                                <strong>{item.company + '-' + item.position_name}</strong>
                                {item.current_stage}
                            </div>
                        )
                    })
                    }
                </PopOver>
                </div>
            </td>
        )
    }
    /* {props.dataItem.positionStatus.map((item: any) => {
    return item.current_stage
  }) } */
    else {
        return (
            <td>
                <div>
                    {props.dataItem.positionStatus && props.dataItem.positionStatus.map((item: any) => {
                        return (
                            <div className="positionList noPadd">
                                <strong>{item.company} - {item.position_name}</strong>
                                {item.current_stage}
                            </div>
                        )
                    })}
                </div>

            </td>
        )
    }
}

const ellowStatusDropdown = (props: GridCellProps, getTableValues: any, rejected: any, blackListed: any) => {

    const { dataItem } = props;
    const field = props.field || '';

    const dataValue = dataItem[field] === null ? '' : dataItem[field];


    const updateStatus = (data: any) => {

        let value = {
            "loginId": props.dataItem.loginId,
            "userLoginId": userLoginId,
            "candidateStatus": data
        }
        updateCandidateStatus(value).then((response: any) => {
            if (response && response.status === 1) {
                getTableValues()
            }
        })
    }

    const handleChange = (e: DropDownListChangeEvent) => {
        if (e.value.name === 'F3 - Verified') {
            updateStatus(e.target.value.id)
        }
        if (e.value.name === 'F99 - Rejected') {
            rejected()
        }
        if (e.value.name === 'F100- Blacklisted') {
            blackListed()
        }
    }


    return (
        <td>
            {dataItem && dataItem.inEdit ? (
                <DropDownList
                    style={{ width: "100%" }}
                    data={CONSTANTS.candidateStatus}
                    onChange={handleChange}
                    dataItemKey='id'
                    textField="name"
                />
            ) : (dataValue)}
        </td>
    )
}

